export default __webpack_public_path__ + "static/media/FAQ_10_3.6297dc6d.png";